import React, { useState } from 'react'
import axios from 'axios';

function ForgotPassword({show, onClose, onSuccess}) {

    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const clearFields = () => {
        setEmail('');
        setErrorMessage('');
    };
    const handleClose = () => {
        clearFields();
        onClose();
    };
    axios.defaults.withCredentials = true;
    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if(!email){
            setErrorMessage('Please fill all fields');
            setIsLoading(false);
            return;
        }

        axios.post('http://localhost:3001/forgot-password', {email})
        .then(result => {
            console.log(result);
            if(result.data.message) {
                clearFields();
                onSuccess();
            } else {
                setErrorMessage(result.data.error || "Failed to send reset link")
            }
        })
        .catch(err => {
                console.log(err);
                setErrorMessage('Failed to send reset link. Please try again.');
            })
            .finally(() => {
                setIsLoading(false);
            })
    };



    return (
        <div className="auth-modal-overlay" style={{ display: show ? 'flex' : 'none' }}>
          <div className="auth-modal-content">
            <span className="auth-close-btn" onClick={handleClose}>&times;</span>
            <h2 className="auth-modal-title">TATA CLiQ FASHION</h2>
    
            <div className='bg-white p-3 rounded w-250'>
                    <h2>Forgot Password</h2>
                    {errorMessage && <div className='alert alert-danger'>{errorMessage}</div>}
                        <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="email"><strong>Email</strong></label>
                                    <input type="email" 
                                    value={email}
                                    className='form-control rounded-0'
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    />
                                </div>
                                <button 
                                type='submit' 
                                className='btn btn-success w-100 rounded-0'
                                disabled={isLoading}
                                >
                                    {isLoading ? 'Sending...' : 'Send Reset Link'}
                                </button>
                        </form>
            </div>
          </div>
        </div>
      )
}

export default ForgotPassword